import React from "react"
import Layout from "../components/layout/Layout"
import VideoSection from "../components/videoSection/VideoSection"
import InfoLector from "../components/info-lector/InfoLector"
import { useStaticQuery, graphql } from "gatsby"
import CourseGoal from "../components/CourseGoal/CourseGoal"
import CourseList from "../components/CourseList/CourseList"
// import VideoPlayer from '../components/videoPlayer/VideoPlayer'
import Form from "../components/form/Form"

const query = graphql`
  {
    allStrapiHomePage {
      nodes {
        course_goal {
          title
          description
          button {
            button_title
            button_arrow {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
              }
            }
            submit
          }
        }
        course_list {
          button {
            button_arrow {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
              }
            }
            button_title
            submit
          }
          imgWithText {
            image_description
            portrait {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
              }
            }
          }
        }
        form_section {
          button {
            button_title
            button_arrow {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
              }
            }
            submit
          }
          input {
            id
            placeholder
            type
          }
          title
          sub_title
        }
        header {
          button {
            button_arrow {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
              }
            }
            submit
            button_title
          }
        }
        lecturer {
          description
          button {
            button_title
            button_arrow {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
              }
            }
          }
          lecturer_name
          title
          lecturer_img {
            localFile {
              childImageSharp {
                gatsbyImageData
              }
            }
          }
        }
        video_section {
          button {
            button_arrow {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
              }
            }
            button_title
            submit
          }
          title
          sub_title
          video
          promo {
            actual_price
            discount
            promo_price
            time_left
          }
        }
      }
    }
  }
`

const IndexPage = () => {
  const data = useStaticQuery(query)

  return (
    <Layout pageMode={"index"}>
      <VideoSection
        videoSectionData={data.allStrapiHomePage.nodes[0].video_section}
      />
      <CourseGoal info={data.allStrapiHomePage.nodes[0].course_goal} />
      <CourseList info={data.allStrapiHomePage.nodes[0].course_list} />
      <InfoLector data={data.allStrapiHomePage.nodes[0].lecturer} />
      <Form data={data.allStrapiHomePage.nodes[0].form_section} />

      {/* <VideoPlayer videoPlayer={data.allStrapiHomePage.nodes[0].video_section} /> */}
    </Layout>
  )
}

export default IndexPage
